




















// @ts-nocheck
// ^^^^^^^^^^^ Disabled TypeScript linter in this file because it doesn't understand Vue components
// which is not wrapped in Vue.extend(), and we can't use Vue.extend() in Sanity serializers
// because of how src/components/SanityBlockContent.vue initializes the serializers.

import PolaroidPhotoAlbum from '@/components/PolaroidPhotoAlbum.vue';

export default {
  name: 'SanityPhotoAlbumSerializer',
  components: {
    PolaroidPhotoAlbum,
  },
  props: {
    title: String,
    photos: Array,
    size: String,
    stacked: Boolean,
    albumStyle: {
      type: String,
      default: () => 'polaroid',
    },
    showTitle: Boolean,
  },
};
